// @flow
import React from 'react';
import type { Element } from 'react';

import {
  PRIMARY_BUTTON, SECONDARY_BUTTON, SECONDARY_LIGHT_BUTTON, CTA_BUTTON
} from './constants';

import PrimaryButton from './components/PrimaryButton';
import SecondaryButton from './components/SecondaryButton';
import SecondaryLightButton from './components/SecondaryLightButton';
import CtaButton from './components/CtaButton';

import type { Props } from './types';

export default (props: Props): Element<any> => {
  const { buttonType }: Props = props;

  switch (buttonType) {
    case PRIMARY_BUTTON:
      return <PrimaryButton {...props} />;

    case SECONDARY_BUTTON:
      return <SecondaryButton {...props} />;

    case SECONDARY_LIGHT_BUTTON:
      return <SecondaryLightButton {...props} />;

    case CTA_BUTTON:
      return <CtaButton {...props} />;

    default:
      return <PrimaryButton {...props} />;
  }
};
